const aboutData = {
  titles: [
    "Based in Copenhagen, Denmark.",
    "Co-founder & CTO at Luna Duck Studios.",
    "2nd year MSc in Games student at IT University of Copenhagen.",
    "BSc in Computer Science at Hebrew U with a 2-year Game Development VC Track at Bezalel Academy.",
    "Michael's dad :)",
  ],
  enquiries: "evyatar.e.cohen@gmail.com",
  selectedPress: [
      { title: "Arkaden", link: "https://arkaden.dk/features/hojdepunkter-fra-copenhagen-gaming-week-vores-mest-ventede-spil"},
      { title: "The Marker", link: "https://www.themarker.com/captain-internet/2025-05-26/ty-article/00000197-0be3-dff8-abff-9be7c1280000"},
      { title: "Eurekalert", link: "https://www.eurekalert.org/news-releases/1069654" },
      { title: "Bezalel News", link: "https://www.bezalel.ac.il/en/news/662015" },
      { title: "Takshahis", link: "https://www.facebook.com/watch/?v=1199304467854134" },
  ],
  talk_workshops: [
  ],
  exhibitions: [
    { title: "FDG: Research Through Games", year: 2026, location: "Copenhagen, Denmark" },
    { title: "TAGS: CPH Gaming Week", year: 2026, location: "Copenhagen, Denmark" },
    { title: "Shaon Horef Festival", year: 2026, location: "Jerusalem, Israel" },
    { title: "Hansen House: Level Up", year: 2025, location: "Jerusalem, Israel" },
    { title: "Rode Hond", year: 2025, location: "Leuven, Belgium" },
    { title: "Cinekid", year: 2025, location: "Amsterdam, Netherlands" },
    { title: "TrikFilm", year: 2025, location: "Ostrava, Czechia" },
    { title: "Gamescom", year: 2025, location: "Cologne, Germany" },
    { title: "Tisff", year: 2025, location: "Tel Aviv, Israel"},
    { title: "A MAZE.", year: 2025, location: "Berlin, Germany" },
    { title: "Milestones", year: 2025, location: "Jerusalem, Israel" },
    { title: "Sparks", year: 2025, location: "Tel Aviv, Israel" },
    { title: "Boston Festival of Indie Games", year: 2024, location: "Boston, USA" },
    { title: "Bezalel Graduate Exhibition", year: 2024, location: "Jerusalem, Israel" }
  ],
awards: [
  { title: "Best Student Game, Unity", year: 2025, result: "Finalist" },
  { title: "Best Game Award, Cinekid", year: 2025, result: "Finalist" },
  { title: "Best Student Interactive Project, TrikFilm", year: 2025, result: "Finalist" },
  { title: "Best Digital Project, TISFF", year: 2025, result: "Winner" },
  { title: "Audience Award, A MAZE. Berlin", year: 2025, result: "Winner" },
  { title: "Best Student Game, GDWC Winter Season", year: 2024, result: "Winner" },
  { title: "Best Game Design, BostonFIG", year: 2024, result: "Winner" },
  { title: "Excellence in Design, Maizler Award", year: 2024, result: "Winner" }
]

};

export default aboutData;